/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/** This is for hide/unhide textbox **/

	$(document).ready(function() {
      $('[id="Personalisation"]').change(function(){
  console.log(this.value)
  if (this.value === 'Engraving') {
    document.getElementById('engraving text').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('engraving text').parentElement.removeAttribute('style');
    document.getElementById('font').parentElement.removeAttribute('style');
    document.getElementById('additional-request-if-any').parentElement.removeAttribute('style');
  } else if (this.value === 'No engraving') {
     document.getElementById('engraving text').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('engraving text').parentElement.style.display = 'none';
    document.getElementById('font').parentElement.style.display = 'none';
    document.getElementById('additional-request-if-any').parentElement.style.display = 'none';
  }
})
});

/** This is beads bracelet**/

$(document).ready(function(){
  $("#Birthstone").click(function(){
  document.getElementById('birthstone').value="";
    document.getElementById('birthstone').parentElement.removeAttribute('style');
    document.getElementById('birthstone').disabled = false;
       document.getElementById('horoscope').value="";
    document.getElementById('horoscope').parentElement.style.display = 'none';
    document.getElementById('horoscope').disabled = true;
  });
  $("#Horoscope").click(function(){
   document.getElementById('horoscope').value="";
    document.getElementById('horoscope').parentElement.removeAttribute('style');
    document.getElementById('horoscope').disabled = false;
    document.getElementById('birthstone').value="";
    document.getElementById('birthstone').parentElement.style.display = 'none';
    document.getElementById('birthstone').disabled = true;
  });
});

$(document).ready(function() {
      $('[id="selectcharm"]').change(function(){
  console.log(this.value)
  if (this.value === 'Birthstone') {
    document.getElementById('birthstone').value="";
    document.getElementById('horoscope').value="";
    document.getElementById('initial').value="";
    document.getElementById('birthstone').parentElement.removeAttribute('style');
    document.getElementById('horoscope').parentElement.style.display = 'none';
    document.getElementById('initial').parentElement.style.display = 'none';
  } else if (this.value === 'Horoscope') {
    document.getElementById('birthstone').value="";
    document.getElementById('horoscope').value="";
    document.getElementById('initial').value="";
    document.getElementById('horoscope').parentElement.removeAttribute('style');
    document.getElementById('birthstone').parentElement.style.display = 'none';
    document.getElementById('initial').parentElement.style.display = 'none';
  }
})
});

/** Thea **/

$(document).ready(function() {
       $('[id="PersonalisationT"]').change(function(){
  console.log(this.value)
  if (this.value === 'Engraving') {
    document.getElementById('first-side').value="";
    document.getElementById('second-side').value="";
    document.getElementById('third-side').value="";
    document.getElementById('fourth-side').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('first-side').parentElement.removeAttribute('style');
    document.getElementById('second-side').parentElement.removeAttribute('style');
    document.getElementById('third-side').parentElement.removeAttribute('style');
    document.getElementById('fourth-side').parentElement.removeAttribute('style');
    document.getElementById('font').parentElement.removeAttribute('style');
    document.getElementById('additional-request-if-any').parentElement.removeAttribute('style');
  } else if (this.value === 'No engraving') {
    document.getElementById('first-side').value="";
    document.getElementById('second-side').value="";
    document.getElementById('third-side').value="";
    document.getElementById('fourth-side').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('first-side').parentElement.style.display = 'none';
    document.getElementById('second-side').parentElement.style.display = 'none';
    document.getElementById('third-side').parentElement.style.display = 'none';
    document.getElementById('fourth-side').parentElement.style.display = 'none';
    document.getElementById('font').parentElement.style.display = 'none';
    document.getElementById('additional-request-if-any').parentElement.style.display = 'none';
  }
})
});


function fillHidden(hiddenname) {
    var checkboxes = document.querySelectorAll('[hidden-data="'+hiddenname+'"]');
    var hiddenfield = document.getElementById(hiddenname);
    hiddenfield.value = ""
    var i;
    for (i = 0; i < checkboxes.length; i++) {
      var x = checkboxes[i];
      if(x.checked){
        if(hiddenfield.value==""){
          hiddenfield.value = x.value;
          }else{
          hiddenfield.value = hiddenfield.value + ", " + x.value; 
          } 
        }
      }
    };
 
$("input.vis-hidden").click(function() {
var bol = $("input.vis-hidden:checked").length >= 3;     
$("input.vis-hidden").not(":checked").attr("disabled",bol);
});

$("input.vis-hidden5").click(function() {
var bol = $("input.vis-hidden5:checked").length >= 5;     
$("input.vis-hidden5").not(":checked").attr("disabled",bol);
});

$("input.vis-hidden8").click(function() {
var bol = $("input.vis-hidden8:checked").length >= 8;     
$("input.vis-hidden8").not(":checked").attr("disabled",bol);
});